module.exports = __webpack_public_path__ + "img/2-7.7bbd5666.png";